export default "__VITE_ASSET__BC2FLm7H__"